import { axios } from "@v2/shared/api";
const PARTICIPANT_ENDPOINT = "participants";

export default {
  add(eventId, companies) {
    return axios.post(
      `${PARTICIPANT_ENDPOINT}/${eventId}/sub-${PARTICIPANT_ENDPOINT}`,
      { companies }
    );
  },

  update(eventId, id, data = {}) {
    return axios.put(
      `${PARTICIPANT_ENDPOINT}/${eventId}/sub-${PARTICIPANT_ENDPOINT}/${id}`,
      data
    );
  },

  delete(eventId, id) {
    return axios.delete(
      `${PARTICIPANT_ENDPOINT}/${eventId}/sub-${PARTICIPANT_ENDPOINT}/${id}`
    );
  },
  deleteAll(eventId) {
    return axios.delete(
      `${PARTICIPANT_ENDPOINT}/${eventId}/sub-${PARTICIPANT_ENDPOINT}`
    );
  }
};
